import { useState, useCallback } from 'react';

const INITIAL_STATE = {
  company: '',
  name: '',
  email: '',
  phone: '',
  subject: '',
  message: '',
};

const ERROR_COPY = {
  fr: "Une erreur est survenue. Veuillez réessayer ou nous contacter par email.",
  en: "Something went wrong. Please try again or contact us by email.",
  es: "Ha ocurrido un error. Inténtelo de nuevo o contáctenos por email.",
  ar: "حدث خطأ. يرجى المحاولة مرة أخرى أو التواصل عبر البريد الإلكتروني.",
};

/**
 * Manages the Boidy contact form state and submission.
 * @param {string} lang - current language code (fr|en|es|ar)
 */
export const useContactForm = (lang) => {
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setErrorMessage('');
      setIsLoading(true);
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const res = await fetch(`${backendUrl}/api/contact`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...formData, lang }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        setIsSubmitted(true);
        setTimeout(() => {
          setIsSubmitted(false);
          setFormData(INITIAL_STATE);
        }, 3000);
      } catch {
        setErrorMessage(ERROR_COPY[lang] || ERROR_COPY.fr);
      } finally {
        setIsLoading(false);
      }
    },
    [formData, lang]
  );

  return {
    formData,
    isSubmitted,
    isLoading,
    errorMessage,
    handleChange,
    handleSubmit,
  };
};
